import { useState, useEffect } from "react";
import { useGetSeasonQuery, useSaveSeasonMutation } from "../dashBoardApi";

const SeasonRangePicker = () => {
  const { data: seasonData } = useGetSeasonQuery();
  const [saveSeason, { isLoading: isSaving }] = useSaveSeasonMutation();

  const [from, setFrom] = useState("");
  const [to, setTo]     = useState("");
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (seasonData?.data) {
      setFrom(seasonData.data.start_date || "");
      setTo(seasonData.data.end_date || "");
    }
  }, [seasonData]);

  const handleSave = async () => {
    if (!from || !to) return;
    await saveSeason({ start_date: from, end_date: to });
    setEditing(false);
  };

  const handleCancel = () => {
    if (seasonData?.data) {
      setFrom(seasonData.data.start_date || "");
      setTo(seasonData.data.end_date || "");
    }
    setEditing(false);
  };

  return (
    <div className="season-picker">
      {editing ? (
        <div className="season-picker-edit">
          <span className="season-picker-label">Season:</span>
          <input
            type="date"
            className="season-date-input"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
          />
          <span className="season-picker-sep">→</span>
          <input
            type="date"
            className="season-date-input"
            value={to}
            onChange={(e) => setTo(e.target.value)}
          />
          <button className="season-btn season-btn-save" onClick={handleSave} disabled={isSaving}>
            {isSaving ? "Saving…" : "Save"}
          </button>
          <button className="season-btn season-btn-cancel" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      ) : (
        <button className="season-picker-display" onClick={() => setEditing(true)}>
          <span className="season-picker-icon">📅</span>
          <span className="season-picker-text">
            Season: {from && to ? `${from} → ${to}` : "Set Duration"}
          </span>
          <span className="season-picker-edit-icon">✎</span>
        </button>
      )}
    </div>
  );
};

export default SeasonRangePicker;
